import { getNewConfiguration } from "../../../../../services/uiConfigService";
import { validateWithOtp } from "../../../../../stateManagement/actions/validateOtpPopupActions";
import {
  CART_CONFIG_DOMAIN_NAME,
  CART_CONFIG_DOMAIN_TYPE,
  CART_CONFIG_OBJECT_NAMES,
  INPUT_VALIDATION,
} from "./CartConfigurationUtils";
import { openPopup } from "../../../../../stateManagement/actions/popupActions";
import { configurationAttributeType } from "../../../../../types";

export const validateStringInput = (
  value: string,
  inputValidation: { max: number; min: number }
) => {
  if (value?.length <= inputValidation.min) {
    return `Input length must be more than ${inputValidation.min} characters`;
  } else if (value?.length > inputValidation.max) {
    return `Input length must less than ${inputValidation.max} characters`;
  } else {
    return "";
  }
};
export const validateNumberInput = (
  value: string,
  inputValidation: {
    max: number;
    min: number;
  }
) => {
  const numValue = parseInt(value, 10);
  if (!isNaN(numValue)) {
    value = numValue.toString();
  }
  const numDigits = value?.replace(/[^0-9]/g, "")?.length; // Count only numeric digits

  if (numDigits < inputValidation.min) {
    return `Input must have at least ${inputValidation.min} digits`;
  }

  if (numDigits > inputValidation.max) {
    return `Input must have no more than ${inputValidation.max} digits`;
  }

  if(numValue<=0){
    return  `Input must be greater than 0`;
  }

  return "";
};

export const getOrderConfiguration = async () => {
  try {
    const orderConfiguration = await getNewConfiguration(
      CART_CONFIG_DOMAIN_TYPE
    );
    return orderConfiguration?.domainValues ?? [];
  } catch (error) {
    throw new Error("Error in fetching the config");
  }
};
// getting the configurations ====================
export const getInitialState = (orderConfiguration: Record<string, any>[]) => {
  try {
    if(orderConfiguration.length === 0) return {};
    //delivery date
    const deliveryDateText = findObject(
      orderConfiguration,
      CART_CONFIG_OBJECT_NAMES.orderFulfillmentTimeMessageConfig
    )?.value;
    const deliverydateNumber = findObject(
      orderConfiguration,
      CART_CONFIG_OBJECT_NAMES.orderFulfillmentTimeConfig
    )?.value;
    const deliveryDateType =
      deliveryDateText && deliveryDateText !== "null"
        ? "Text"
        : deliverydateNumber && parseInt(deliverydateNumber) > 0
        ? "Number"
        : "Text";
    //label
    const deliveryTimeLabel = findObject(
      orderConfiguration,
      CART_CONFIG_OBJECT_NAMES.fullFilledByLabelConfig
    )?.value;
    //recommendation carousel
    const missedItemBasketId =
      findObject(orderConfiguration, CART_CONFIG_OBJECT_NAMES.missedItemBasket)
        ?.value ?? "";

    const saveMissedProductCarouselOption =
      !missedItemBasketId || missedItemBasketId === "recommendation"
        ? "Recommended Products"
        : "Personalised Curated Basket";
    const missedProductCarouselEnabled = {
      salesrep: [
        CART_CONFIG_OBJECT_NAMES.missedRecommendationTypeMapping,
        CART_CONFIG_OBJECT_NAMES.discardSuggQtyInMissedRecoPopup,
        CART_CONFIG_OBJECT_NAMES.showMissedRecoPopup,
      ].every((name) => {
        const config = findObject(orderConfiguration, name);
        return (
          config &&
          (name === CART_CONFIG_OBJECT_NAMES.missedRecommendationTypeMapping ||
            config.value === true)
        );
      })
        ? "true"
        : "false",
      retailer: !!missedItemBasketId ? "true" : "false",
    };
    const orderingConditions =
      findObject(
        orderConfiguration,
        CART_CONFIG_OBJECT_NAMES.orderingConditions
      )?.value ;
    const orderValidationTypes = orderingConditions?.type?.sort().join(",");
    const orderingCriteriaType =
      orderingConditions?.criteria?.sort().join(",") +
      (orderingConditions?.criteria?.length === 2
        ? "," + orderingConditions?.condition
        : "");

    const persistentCartNavigationBar = findObject(
      orderConfiguration,
      CART_CONFIG_OBJECT_NAMES.persistentCartNavigationBar
    )?.value;
    return {
      deliveryDateType: deliveryDateType,
      deliveryDateValueText: deliveryDateText==="null" ? "By Next Delivery" : deliveryDateText,
      deliveryDateValueNumber:  String(deliverydateNumber),
      deliveryTimeLabel: String(deliveryTimeLabel),
      missedProductCarouselEnabledSalesRep:
        missedProductCarouselEnabled["salesrep"],
      missedProductCarouselEnabledRetailer:
        missedProductCarouselEnabled["retailer"],
      missedProductCarouselOption: saveMissedProductCarouselOption,
      missedItemBasketId: missedItemBasketId,
      min_value: orderingConditions?.min_value?.toString(),
      max_value: orderingConditions?.max_value?.toString(),
      min_quantity: orderingConditions?.min_quantity?.toString(),
      max_quantity: orderingConditions?.max_quantity?.toString(),
      orderValidationType: orderValidationTypes,
      orderingCriteriaType: orderingCriteriaType,
      orderingValidationTypeCriteriaCondition: orderingConditions?.condition,
      persistentCartNavigationBar : persistentCartNavigationBar
    };
  } catch (error) {
    throw new Error("Error in fetching the config");
  }
};
export const getInitialStateOrderingConditions= (orderConfiguration: Record<string, any>[]) => {
  try {
    if(orderConfiguration.length === 0) return {};
    //delivery date
    
    const orderingConditions =
      findObject(
        orderConfiguration,
        CART_CONFIG_OBJECT_NAMES.orderingConditions
      )?.value ;
    const orderValidationTypes = orderingConditions?.type?.sort().join(",");
    const orderingCriteriaType =
      orderingConditions?.criteria?.sort().join(",") +
      (orderingConditions?.criteria?.length === 2
        ? "," + orderingConditions?.condition
        : "");

   
    return {
      min_value: orderingConditions?.min_value?.toString(),
      max_value: orderingConditions?.max_value?.toString(),
      min_quantity: orderingConditions?.min_quantity?.toString(),
      max_quantity: orderingConditions?.max_quantity?.toString(),
      orderValidationType: orderValidationTypes,
      orderingCriteriaType: orderingCriteriaType,
      orderingValidationTypeCriteriaCondition: orderingConditions?.condition,
    };
  } catch (error) {
    throw new Error("Error in fetching the config");
  }
};
export const getInitialStateMissedItemBasket = (orderConfiguration: Record<string, any>[]) => {
  try {
    if(orderConfiguration.length === 0) return {};
    //delivery date
    
    
    //recommendation carousel
    const missedItemBasketId =
      findObject(orderConfiguration, CART_CONFIG_OBJECT_NAMES.missedItemBasket)
        ?.value ?? "";

    const saveMissedProductCarouselOption =
      !missedItemBasketId || missedItemBasketId === "recommendation"
        ? "Recommended Products"
        : "Personalised Curated Basket";
    const missedProductCarouselEnabled = {
      salesrep: [
        CART_CONFIG_OBJECT_NAMES.missedRecommendationTypeMapping,
        CART_CONFIG_OBJECT_NAMES.discardSuggQtyInMissedRecoPopup,
        CART_CONFIG_OBJECT_NAMES.showMissedRecoPopup,
      ].every((name) => {
        const config = findObject(orderConfiguration, name);
        return (
          config &&
          (name === CART_CONFIG_OBJECT_NAMES.missedRecommendationTypeMapping ||
            config.value === true)
        );
      })
        ? "true"
        : "false",
      retailer: !!missedItemBasketId ? "true" : "false",
    };
   
    return {
      missedProductCarouselEnabledSalesRep:
        missedProductCarouselEnabled["salesrep"],
      missedProductCarouselEnabledRetailer:
        missedProductCarouselEnabled["retailer"],
      missedProductCarouselOption: saveMissedProductCarouselOption,
      missedItemBasketId: missedItemBasketId,
    
    };
  } catch (error) {
    throw new Error("Error in fetching the config");
  }
};
export const getInitialStateOrderFulfillment = (orderConfiguration: Record<string, any>[]) => {
  try {
    if(orderConfiguration.length === 0) return {};
    //delivery date
    const deliveryDateText = findObject(
      orderConfiguration,
      CART_CONFIG_OBJECT_NAMES.orderFulfillmentTimeMessageConfig
    )?.value;
    const deliverydateNumber = findObject(
      orderConfiguration,
      CART_CONFIG_OBJECT_NAMES.orderFulfillmentTimeConfig
    )?.value;
    const deliveryDateType =
      deliveryDateText && deliveryDateText !== "null"
        ? "Text"
        : deliverydateNumber && parseInt(deliverydateNumber) > 0
        ? "Number"
        : "Text";
    //label
    const deliveryTimeLabel = findObject(
      orderConfiguration,
      CART_CONFIG_OBJECT_NAMES.fullFilledByLabelConfig
    )?.value;
    //recommendation carousel

  
    return {
      deliveryDateType: deliveryDateType,
      deliveryDateValueText: deliveryDateText==="null" ? "By Next Delivery" : deliveryDateText,
      deliveryDateValueNumber:  String(deliverydateNumber),
      deliveryTimeLabel: String(deliveryTimeLabel),
    };
  } catch (error) {
    throw new Error("Error in fetching the config");
  }
};
export const getAvalableBuckets = async () => {
  try {
    const orderBasketConfiguration = await getNewConfiguration(
      "order_basket_configuration"
    );
    const availableBaskets =
      orderBasketConfiguration.domainValues
        .find((item: any) => item.name === "orderBasketMapping")
        ?.value.map((item: any) => {
          return {
            id: item.id,
            title: item.title,
          };
        }) ?? [];
    return availableBaskets ?? [];
  } catch (error) {}
};
const findObject = (data: Record<string, any>[], key: string) => {
  return data.find((item) => item.name === key);
};
// saving the configurations ====================
export const saveCartConfig = async (
  values: Record<string, any>,
  init: () => void
) => {
  try {
    const updateRequestBody = {
      lob: JSON.parse(localStorage.authContext).user.lob,
      domainName: CART_CONFIG_DOMAIN_NAME,
      domainType: CART_CONFIG_DOMAIN_TYPE,
      domainValues: values,
    };
    const api = `/metadata/${updateRequestBody.domainName}?name=${updateRequestBody.domainType}`;
    const apiType = "PUT";
    const response = await validateWithOtp(
      (verifiedUser, verifyResponse) => {
        if (verifyResponse.status === 200 || verifyResponse.status === 201) {
          openPopup("Success", "Config saved successfully", () => {});
          init();
        } else {
          throw new Error("Some error occured while saving data");
        }
      },
      undefined,
      "all",
      api,
      updateRequestBody,
      apiType
    );
  } catch (error) {
    throw new Error("Error in saving the config");
  }
};
export const convertValuesToConfig_cartConfiguration = (
  inputStateValues: Record<string, any>,
  defaultConfig: Record<string, any>,
  orderConfiguration: configurationAttributeType[],
  savedRole: string
): { [key: string]: configurationAttributeType<any> } => {
  const mergedConfig = { ...defaultConfig };

  orderConfiguration.forEach((config) => {
    mergedConfig[config.name] = config;
  });

  const updatedConfiguration = Object.keys(mergedConfig).map((key) => {
    const config = mergedConfig[key];

    switch (config.name) {
      case CART_CONFIG_OBJECT_NAMES.orderFulfillmentTimeMessageConfig:
        if (inputStateValues.deliveryDateType === "Text") {
          return {
            [config.name]: {
              ...config,
              value:
          inputStateValues.deliveryDateValueText,
              // isValueUpdated: inputStateValues.deliveryDateValueText !== initialStateValues.deliveryDateValueText,
              isValueUpdated: true,
              domainType: CART_CONFIG_DOMAIN_TYPE,
            },
          };
        } else {
          //returning null because in app side they use the number value only when this is nul
          return {
            [config.name]: {
              ...config,
              value: "null",
              isValueUpdated: true,
              domainType: CART_CONFIG_DOMAIN_TYPE,
            },
          };
        }

      case CART_CONFIG_OBJECT_NAMES.orderFulfillmentTimeConfig:
        if (inputStateValues.deliveryDateType === "Number") {
          return {
            [config.name]: {
              ...config,
              value: parseInt(
                inputStateValues.deliveryDateValueNumber || "1",
                10
              ),
              // isValueUpdated: (inputStateValues.deliveryDateValueNumber || "1") !== initialStateValues.deliveryDateValueNumber,
              isValueUpdated: true,
              domainType: CART_CONFIG_DOMAIN_TYPE,
            },
          };
        }
        break;

      case CART_CONFIG_OBJECT_NAMES.fullFilledByLabelConfig:
        return {
          [config.name]: {
            ...config,
            value: inputStateValues.deliveryTimeLabel ?? "Delivered By",
            // isValueUpdated: inputStateValues.deliveryTimeLabel !== initialStateValues.deliveryTimeLabel,
            isValueUpdated: true,
            domainType: CART_CONFIG_DOMAIN_TYPE,
          },
        };
      case CART_CONFIG_OBJECT_NAMES.missedItemBasket:
        if (savedRole === "retailer") {
          if (
            inputStateValues.missedProductCarouselEnabledRetailer === "true"
          ) {
            if (
              inputStateValues.missedProductCarouselOption ===
                "Personalised Curated Basket" &&
              inputStateValues.missedItemBasketId
            ) {
              return {
                [config.name]: {
                  ...config,
                  value: inputStateValues.missedItemBasketId,
                  isValueUpdated: true,
                  domainType: CART_CONFIG_DOMAIN_TYPE,
                },
              };
            } else {
              return {
                [config.name]: {
                  ...config,
                  value: "recommendation",
                  isValueUpdated: true,
                  domainType: CART_CONFIG_DOMAIN_TYPE,
                },
              };
            }
          } else {
            return null; // Remove the object if value is false
          }
        } else {
          return {
            [config.name]: {
              ...config,
              domainType: CART_CONFIG_DOMAIN_TYPE,
            },
          };
        }

      case CART_CONFIG_OBJECT_NAMES.missedRecommendationTypeMapping:
      case CART_CONFIG_OBJECT_NAMES.discardSuggQtyInMissedRecoPopup:
      case CART_CONFIG_OBJECT_NAMES.showMissedRecoPopup:
        if (savedRole === "salesrep") {
          if (
            inputStateValues.missedProductCarouselEnabledSalesRep === "true"
          ) {
            if (config.type === "Object") {
              return {
                [config.name]: {
                  ...config,
                  value: {
                    "1": "Cross Sell",
                    "2": "Recover",
                  },
                  isValueUpdated: true,
                  domainType: CART_CONFIG_DOMAIN_TYPE,
                },
              };
            } else if (config.type === "boolean") {
              return {
                [config.name]: {
                  ...config,
                  value: true,
                  isValueUpdated: true,
                  domainType: CART_CONFIG_DOMAIN_TYPE,
                },
              };
            } else {
              return {
                [config.name]: {
                  ...config,
                  isValueUpdated: true,
                  domainType: CART_CONFIG_DOMAIN_TYPE,
                },
              };
            }
          } else {
            return null; // Remove the object if value is false
          }
        } else {
          return {
            [config.name]: {
              ...config,
              domainType: CART_CONFIG_DOMAIN_TYPE,
            },
          };
        }
      case CART_CONFIG_OBJECT_NAMES.orderingConditions: {
        // ;
        const max_value = parseInt(inputStateValues?.max_value ?? "0");
        const min_value = parseInt(inputStateValues?.min_value ?? "0");
        const max_quantity = parseInt(inputStateValues?.max_quantity ?? "0");
        const min_quantity = parseInt(inputStateValues?.min_quantity ?? "0");
        const orderValidationType = inputStateValues?.orderValidationType
          ?.split(",")
          ?.sort();
        const orderingCriteriaType = (
          inputStateValues?.orderingCriteriaType?.split(",").length === 3
            ? inputStateValues?.orderingCriteriaType?.split(",")?.slice(0, 2)
            : inputStateValues?.orderingCriteriaType?.split(",")
        )?.sort();
        const orderingValidationTypeCriteriaCondition =
          inputStateValues?.orderingValidationTypeCriteriaCondition;
        return {
          [config.name]: {
            ...config,
            value: {
              max_value: max_value,
              min_value: min_value,
              max_quantity: max_quantity,
              min_quantity: min_quantity,
              type: orderValidationType,
              criteria: orderingCriteriaType,
              condition: orderingValidationTypeCriteriaCondition,
            },
            isValueUpdated: true,
            domainType: CART_CONFIG_DOMAIN_TYPE,
          },
        };
      }
      case CART_CONFIG_OBJECT_NAMES.persistentCartNavigationBar:
        return {
          [config.name]: {
            ...config,
            value: inputStateValues?.persistentCartNavigationBar,
            isValueUpdated: true,
            domainType: CART_CONFIG_DOMAIN_TYPE,
          },
        }
      default:
        return {
          [config.name]: {
            ...config,
            domainType: CART_CONFIG_DOMAIN_TYPE,
          },
        };
    }
    return null; // Ensure null is returned for cases where no config should be included
  });
  // Filter out null values
  return Object.assign({}, ...updatedConfiguration.filter(Boolean));
};

export const convertValuesToConfig_cartConfigurationNew = (
  inputStateValues: Record<string, any>,
  defaultConfig: Record<string, any>,
  savedRole: string
): { [key: string]: configurationAttributeType<any> } => {
  const mergedConfig = { ...defaultConfig };

  const updatedConfiguration = Object.keys(mergedConfig).map((key) => {
    const config = mergedConfig[key];

    switch (config.name) {
      case CART_CONFIG_OBJECT_NAMES.orderFulfillmentTimeMessageConfig:
        if (inputStateValues.deliveryDateType === "Text") {
          return {
            [config.name]: {
              ...config,
              value:
          inputStateValues.deliveryDateValueText,
              // isValueUpdated: inputStateValues.deliveryDateValueText !== initialStateValues.deliveryDateValueText,
              isValueUpdated: true,
              domainType: CART_CONFIG_DOMAIN_TYPE,
            },
          };
        } else {
          //returning null because in app side they use the number value only when this is nul
          return {
            [config.name]: {
              ...config,
              value: "null",
              isValueUpdated: true,
              domainType: CART_CONFIG_DOMAIN_TYPE,
            },
          };
        }

      case CART_CONFIG_OBJECT_NAMES.orderFulfillmentTimeConfig:
        if (inputStateValues.deliveryDateType === "Number") {
          return {
            [config.name]: {
              ...config,
              value: parseInt(
                inputStateValues.deliveryDateValueNumber || "1",
                10
              ),
              // isValueUpdated: (inputStateValues.deliveryDateValueNumber || "1") !== initialStateValues.deliveryDateValueNumber,
              isValueUpdated: true,
              domainType: CART_CONFIG_DOMAIN_TYPE,
            },
          };
        }
        break;

      case CART_CONFIG_OBJECT_NAMES.missedItemBasket:
        if (savedRole === "retailer") {
          if (
            inputStateValues.missedProductCarouselEnabledRetailer === "true"
          ) {
            if (
              inputStateValues.missedProductCarouselOption ===
                "Personalised Curated Basket" &&
              inputStateValues.missedItemBasketId
            ) {
              return {
                [config.name]: {
                  ...config,
                  value: inputStateValues.missedItemBasketId,
                  isValueUpdated: true,
                  domainType: CART_CONFIG_DOMAIN_TYPE,
                },
              };
            } else {
              return {
                [config.name]: {
                  ...config,
                  value: "recommendation",
                  isValueUpdated: true,
                  domainType: CART_CONFIG_DOMAIN_TYPE,
                },
              };
            }
          } else {
            return null; // Remove the object if value is false
          }
        } else {
          return {
            [config.name]: {
              ...config,
              domainType: CART_CONFIG_DOMAIN_TYPE,
            },
          };
        }

      case CART_CONFIG_OBJECT_NAMES.missedRecommendationTypeMapping:
      case CART_CONFIG_OBJECT_NAMES.discardSuggQtyInMissedRecoPopup:
      case CART_CONFIG_OBJECT_NAMES.showMissedRecoPopup:
        if (savedRole === "salesrep") {
          if (
            inputStateValues.missedProductCarouselEnabledSalesRep === "true"
          ) {
            if (config.type === "Object") {
              return {
                [config.name]: {
                  ...config,
                  value: {
                    "1": "Cross Sell",
                    "2": "Recover",
                  },
                  isValueUpdated: true,
                  domainType: CART_CONFIG_DOMAIN_TYPE,
                },
              };
            } else if (config.type === "boolean") {
              return {
                [config.name]: {
                  ...config,
                  value: true,
                  isValueUpdated: true,
                  domainType: CART_CONFIG_DOMAIN_TYPE,
                },
              };
            } else {
              return {
                [config.name]: {
                  ...config,
                  isValueUpdated: true,
                  domainType: CART_CONFIG_DOMAIN_TYPE,
                },
              };
            }
          } else {
            return null; // Remove the object if value is false
          }
        } else {
          return {
            [config.name]: {
              ...config,
              domainType: CART_CONFIG_DOMAIN_TYPE,
            },
          };
        }
      case CART_CONFIG_OBJECT_NAMES.orderingConditions: {
        // ;
        const max_value = parseInt(inputStateValues?.max_value ?? "0");
        const min_value = parseInt(inputStateValues?.min_value ?? "0");
        const max_quantity = parseInt(inputStateValues?.max_quantity ?? "0");
        const min_quantity = parseInt(inputStateValues?.min_quantity ?? "0");
        const orderValidationType = inputStateValues?.orderValidationType
          ?.split(",")
          ?.sort();
        const orderingCriteriaType = (
          inputStateValues?.orderingCriteriaType?.split(",").length === 3
            ? inputStateValues?.orderingCriteriaType?.split(",")?.slice(0, 2)
            : inputStateValues?.orderingCriteriaType?.split(",")
        )?.sort();
        const orderingValidationTypeCriteriaCondition =
          inputStateValues?.orderingValidationTypeCriteriaCondition;
        return {
          [config.name]: {
            ...config,
            value: {
               type: orderValidationType,
              criteria: orderingCriteriaType,
              condition: orderingValidationTypeCriteriaCondition,
              max_value: max_value,
              min_value: min_value,
              max_quantity: max_quantity,
              min_quantity: min_quantity,
             
            },
            isValueUpdated: true,
            domainType: CART_CONFIG_DOMAIN_TYPE,
          },
        };
      }
      
      default:
        return {
          [config.name]: {
            ...config,
            domainType: CART_CONFIG_DOMAIN_TYPE,
          },
        };
    }
    return null; // Ensure null is returned for cases where no config should be included
  });
  // Filter out null values
  return Object.assign({}, ...updatedConfiguration.filter(Boolean));
};


// validating the data fields ====================
export const validateDataFieldValues = (values: Record<string, any>) => {
  if (!values || Object.keys(values).length === 0) {
    return false;
  }
  // ;
  if (values?.deliveryDateType === "Text") {
    if (
      validateStringInput(
        values?.deliveryDateValueText,
        INPUT_VALIDATION.deliveryDateValue.text
      )
    )
      return false;
  } else if (values?.deliveryDateType === "Number") {
    if (
      validateNumberInput(
        values?.deliveryDateValueNumber,
        INPUT_VALIDATION.deliveryDateValue.number
      )
    )
      return false;
  }
  if (
    validateStringInput(
      values?.deliveryTimeLabel,
      INPUT_VALIDATION.deliveryTimeLabel
    )
  )
    return false;
  // ;
  const orderValidationTypes = values?.orderValidationType?.split(",") ?? [];
  const orderingCriteriaTypes = values?.orderingCriteriaType
    ? values?.orderingCriteriaType
        .split(",")
        .slice(0, Math.min(2, values?.orderingCriteriaType?.split(",")?.length))
    : [];

  // Ensure orderValidationTypes and orderingCriteriaTypes are valid arrays
  if (
    !Array.isArray(orderValidationTypes) ||
    !Array.isArray(orderingCriteriaTypes) ||
    orderValidationTypes.length === 0 ||
    orderingCriteriaTypes.length === 0
  ) {
    return false;
  }

  // Loop through validation and criteria types
  for (const validationType of orderValidationTypes) {
    for (const criteriaType of orderingCriteriaTypes) {
      const key = `${validationType}_${criteriaType}`;
      if (values?.[key] !== undefined) {
        const valueToValidate = typeof values[key] === "number" ? values[key].toString() : values[key];
        if (validateNumberInput(valueToValidate, INPUT_VALIDATION.minMaxValueQuanitity)) {
          return false;
        }
      }
    }
  }

  // If both "min" and "max" validation types exist, ensure minValue < maxValue
  if(isMinLessThanMax(values)?.length !== 0)
      return false;
  return true;
};
export const isMinLessThanMax = (
  values: Record<string, any>,
  param?: string
): string => {
  // ;
  const orderValidationTypes = values?.orderValidationType?.split(",") ?? [];
  const orderingCriteriaTypes = values?.orderingCriteriaType
    ? values?.orderingCriteriaType
        .split(",")
        .slice(0, Math.min(2, values?.orderingCriteriaType?.split(",")?.length))
    : [];
  if (orderValidationTypes.length === 2 && orderingCriteriaTypes.length === 1) {
    const criteria = orderingCriteriaTypes[0]; // Single ordering criteria type

    const minValue = parseInt(values?.[`min_${criteria}`], 10);
    const maxValue = parseInt(values?.[`max_${criteria}`], 10);

    if (!isNaN(minValue) && !isNaN(maxValue) && minValue >= maxValue) {
      // ;
      if (param === "max")
        return "Max value should be greater than min value";
      else
        return "Min value should be less than max value";
    }
  }
  return "";
};
